import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { Home } from "./screens/Home/Home";
import { Listing } from "./screens/Listing/Listing";
import { Categories } from "./screens/Categories/Categories";
import { CardDetails } from "./screens/CardDetails/CardDetails";
import { Login } from "./screens/Auth/Login";
import { SignUp } from "./screens/Auth/SignUp";
import { Profile } from "./screens/Profile/Profile";
import { OrganizerProfile } from "./screens/OrganizerProfile/OrganizerProfile";
import { About } from "./screens/StaticPages/About";
import { FAQ } from "./screens/StaticPages/FAQ";
import { Contact } from "./screens/StaticPages/Contact";
import { Careers } from "./screens/StaticPages/Careers";
import { Help } from "./screens/StaticPages/Help";
import { Privacy } from "./screens/StaticPages/Privacy";
import { Terms } from "./screens/StaticPages/Terms";
import { Blogs } from "./screens/Blogs/Blogs";
import { ForBusiness } from "./screens/ForBusiness/ForBusiness";
import WebflowObserver from "./components/WebflowObserver";

function App() {
  return (
    <Router>
      <WebflowObserver />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/categories" element={<Categories />} />
        <Route path="/listing/:id" element={<Listing />} />
        <Route path="/event-details/:id" element={<CardDetails />} />
        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<SignUp />} />
        <Route path="/profile" element={<Profile />} />
        <Route path="/organizer/:id" element={<OrganizerProfile />} />
        <Route path="/blogs" element={<Blogs />} />
        <Route path="/for-business" element={<ForBusiness />} />
        
        {/* Static Pages */}
        <Route path="/about" element={<About />} />
        <Route path="/faq" element={<FAQ />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/careers" element={<Careers />} />
        <Route path="/help" element={<Help />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/terms" element={<Terms />} />
      </Routes>
    </Router>
  );
}

export default App;

